import { atom } from "jotai";

export const rightPanelWidthAtom = atom<number>(512);
